export default {
  title: 'Footer CTA'
}

const Template = args => {
  let gapColumn = args['gap-column'] ? args['gap-column'] : (args.gap ? args.gap : 0);
  let gapRow = args['gap-row'] ? args['gap-row'] : (args.gap ? args.gap : 0);

  return (
    `<cradlepoint-footer-cta
      columns="${args.columns ? args.columns : '1fr auto'}"
      gap-column="${gapColumn}"
      gap-row="${gapRow}"
      background-color="${args['background-color'] ? args['background-color'] : 'var(--cwc-footer-cta-bg, #0FC373)'}"
      max-width="${args['max-width'] ? args['max-width'] : '1350px'}"
      content-width="${args['content-width'] ? args['content-width'] : '1350px'}"
      >
      ${args.content && args.content}
    </cradlepoint-footer-cta>`
  );
}

export const Sunrise = Template.bind({});

Sunrise.args = {
  columns: '1fr auto',
  gap: '',
  'gap-column': '2.5rem',
  'gap-row': '2rem',
  'background-color': 'var(--cwc-color-primary, #FFAD00)',
  'max-width': '',
  'content-width': '',
  content: `
      <h2 class="font-regular" style="margin:auto;">Explore how Cradlepoint can help you unlock the power of LTE and 5G cellular for your network.</h2>

    <cradlepoint-container gap="1rem" columns="repeat(2, 1fr)">
      <cradlepoint-button-cta>
        Wireless Wan
      </cradlepoint-button-cta>
      <cradlepoint-button-cta>
        Private Cellular
      </cradlepoint-button-cta>
    </cradlepoint-container>`
};

export const Examples = () => `
<cradlepoint-container max-width="unset">
  <!-- example with three buttons -->
  <cradlepoint-footer-cta
    columns="1fr 505px"
    gap-column="2.5rem"
    gap-row="2rem"
  >
    <div class="left">
      <h2 class="font-regular" style="margin:auto;">Explore how Cradlepoint can help you unlock the power of LTE and 5G cellular for your network.</h2>
    </div>
    <div>
      <cradlepoint-button-cta>
        Wireless Wan
      </cradlepoint-button-cta>
      <cradlepoint-button-cta>
        Private Cellular
      </cradlepoint-button-cta>
      <cradlepoint-button-cta>
        Request Demo
      </cradlepoint-button-cta>
    </div>
  </cradlepoint-footer-cta>
  <!-- /example with three buttons -->
  <br />
  <!-- example with one buttons -->
  <cradlepoint-footer-cta
    columns="1fr auto"
    gap-column="2.5rem"
    gap-row="2rem"
    background-color="var(--cwc-color-secondary, #333F48)"
  >
    <div class="left">
      <h2 class="font-light" style="margin:auto;">This CTA text is in thin font weight pellentesque nulla eros, mattis ac eros dignissim, imperdiet gravida turpis.</h2>
    </div>
    <div>
      <cradlepoint-button-cta
        background-color="var(--cwc-color-primary, #FFAD00)"
        text-color-hover="var(--cwc-color-primary, #FFAD00)"
        border-color="var(--cwc-color-primary, #FFAD00)"
        link="https://github.com/"
        target="_blank"
      >
        Search Font Awesome Free <i class="fa-solid fa-magnifying-glass" style="margin-left:0.25rem"></i>
      </cradlepoint-button-cta>
    </div>
  </cradlepoint-footer-cta>
</cradlepoint-container>
`
